import Vue from "vue";
import Vuex from "vuex";
import { http } from "../config";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    auth: null,
    role: null
  },
  mutations: {
    setAuth: (state, auth) => (state.auth = auth),
    setRole: (state, role) => (state.role = role),
    removeRole: (state) => (state.role = null),
    logout: state => {
      state.auth = null;
      state.role = null;
    },
  },
  getters: {
    isLoggedIn: state => state.auth !== null,
    hasRole: state => state.role !== null,
  },
  actions: {
    setRole: (ctx, role) => {
      ctx.commit("setRole", role);
      window.localStorage.setItem("role", JSON.stringify(role));
    },
    login: (ctx, user) => {
      // request param => {email: 'dispatcher@test.et', password: 'password', role: 1}
      // response => { dispatcher: {}, role: '', token: '' }
      return new Promise((resolve, reject) => {
        http
          .post("/accounts/auth", user)
          .then(response => {
            console.log(response);
            ctx.commit("setAuth", response.data);
            window.localStorage.setItem("auth", JSON.stringify(response.data));
            resolve(true);
          })
          .catch(err => {
            window.flash({ type: "error", body: "Failed to login!" });
            reject(err);
          });
      });
    },
    logout: ctx => {
      // delete the token
      return new Promise((resolve, reject) => {
        try {
          window.localStorage.removeItem("auth");
          window.localStorage.removeItem("role");
          ctx.commit("logout");
          resolve(true);
        } catch (e) {
          reject(e);
        }
      });
    },
  },
  modules: {},
});
